// actions types

/** datasets page */
export const DATASETS = {
  REQUEST: 'DATASETS.REQUEST',
  REQUEST_FAILED: 'DATASETS.REQUEST_FAILED',
  REQUEST_SUCCEEDED: 'DATASETS.REQUEST_SUCCEEDED',
};

/** facets (panels left pane) */
export const FACETS = {
  REQUEST_TYPES_ALL: 'FACETS.REQUEST_TYPES_ALL',
  REQUEST_TYPES_ALL_FAILED: 'FACETS.REQUEST_TYPES_ALL_FAILED',
  REQUEST_TYPES_ALL_SUCCEEDED: 'FACETS.REQUEST_TYPES_ALL_SUCCEEDED',
  REQUEST_SUBTYPES_ALL: 'FACETS.REQUEST_SUBTYPES_ALL',
  REQUEST_SUBTYPES_ALL_FAILED: 'FACETS.REQUEST_SUBTYPES_ALL_FAILED',
  REQUEST_SUBTYPES_ALL_SUCCEEDED: 'FACETS.REQUEST_SUBTYPES_ALL_SUCCEEDED',
};

/** routing */
export const ROUTE = {
  PUSH: 'ROUTE.PUSH',
  SAVE_LOCATION: 'ROUTE.SAVE_LOCATION'
};

/** open/close tab */
export const TAB = {
  OPEN: 'TAB.OPEN',
  OPEN_SUCCEEDED: 'TAB.OPEN_SUCCEEDED',
  CLOSE: 'TAB.CLOSE',
  CLOSE_SUCCEEDED: 'TAB.CLOSE_SUCCEEDED',
  UPDATE_VIEW_OPTION: 'TAB.UPDATE_VIEW_OPTION',
  UPDATE_MAP_OPTION: 'TAB.UPDATE_MAP_OPTION'
};

/* I refer to dataset entries under pagination
body in the main view simply as cards for now */
export const CARDS = {
  REQUEST: 'CARDS.REQUEST',
  REQUEST_FAILED: 'CARDS.REQUEST_FAILED',
  RECEIVED: 'CARDS.RECEIVED',
  FAILED: 'CARDS.FAILED'
};
